import { wsBase } from "../../auth/api";
import { isDiscordFrame } from "../../utils/frame";

import { API_GRACE_MS, API_RESYNC_THROTTLE_MS, API_BACKOFF_MAX_MS, DETACH_DELAY_MS } from "@cookies/shared/config";
export const WS_POOL_RELEASE_MS = DETACH_DELAY_MS;
export const WS_HEARTBEAT_MS = 20_000;
export const WS_CONNECT_TIMEOUT_MS = API_GRACE_MS;
export const WS_MAX_BACKOFF_MS = API_BACKOFF_MAX_MS;
export const WS_BASE_BACKOFF_MS = 1000;
export const WS_RESYNC_THROTTLE_MS = API_RESYNC_THROTTLE_MS;

function inFrame(): boolean {
  try {
    if (isDiscordFrame()) return true;
    return window.location.hostname.endsWith("discordsays.com");
  } catch {
    return false;
  }
}

export function wsOrigin(): string {
  try {
    if (inFrame()) return "/api";
    const b = wsBase();
    if (b !== "") return b;
    const loc = window.location;
    if (loc.hostname === "localhost" || loc.hostname === "127.0.0.1") return "ws://localhost:3001";
    return (loc.protocol === "https:" ? "wss:" : "ws:") + "//" + loc.host;
  } catch {
    return "";
  }
}

export function wsLabel(): string {
  const b = wsOrigin();
  if (b === "") return "/ws";
  return b === "ws://localhost:3001" ? "ws://localhost:3001" : b + "/ws";
}

export function sharedWsKey(guildId: string, token: string): string {
  return guildId.trim() + ":" + token;
}

export interface ConnectionOptions {
  guildId?: string;
  token?: string;
  userId?: string;
}
